import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from './localStorage/localStorage.service';

@Injectable({
    providedIn: 'root',
})
export class PaginationConfigService {
    private defaultPageSize = 50;
    private defaultPageIndex = 0;
    private defaultPageSkip = 0;
    public _pageSize = new BehaviorSubject<number>(this.defaultPageSize);
    public _pageSizeOptions = new BehaviorSubject<number[]>([5, 10, 25, 50]);
    public _pageIndex = new BehaviorSubject<number>(this.defaultPageIndex);
    public _pageSkip = new BehaviorSubject<number>(this.defaultPageSkip);

    constructor(private localStorageService: LocalStorageService) {
        const pageSize = Number(
            sessionStorage.getItem('pageSize') || this.defaultPageSize
        );
        this.setPageSize(pageSize);
    }

    get pageSize$() {
        return this._pageSize.asObservable();
    }

    get pageSizeOptions$() {
        return this._pageSizeOptions.asObservable();
    }

    get pageIndex$() {
        return this._pageIndex.asObservable();
    }

    get pageSkip$() {
        return this._pageSkip.asObservable();
    }

    setPageSize(newSize: number) {
        if (newSize !== this._pageSize.getValue()) { // Only update if different
            sessionStorage.setItem('pageSize', newSize.toString());
        }
        this._pageSize.next(newSize);
    }

    setPageIndex(newIndex: number) {
        this._pageIndex.next(newIndex);
    }

    setPageSkip(newIndex: number) {
        this._pageSkip.next(newIndex);
    }

    handlePageEvent(event: PageEvent) {
        this.setPageSize(event.pageSize);
        this.setPageIndex(event.pageIndex);
    }

    resetPagination() {
        // this.setPageSize(this.defaultPageSize);
        this.setPageIndex(this.defaultPageIndex);
    }
}
